
type onTickCallback = (countDownInfo: { elapsedTime: number, remainingTime: number, }) => void

/**
 * Creates a countdown-timer.
 * @param {number} durationInSeconds Countdown duration.
 * @param {onTickCallback} onTickCallback Function that will be called on every tick with information about the progres of the countdown.
 */
export default function (durationInSeconds: number, onTickCallback?: onTickCallback) {
  const onTick: onTickCallback = typeof onTickCallback === 'function'
    ? onTickCallback
    : () => {
    };

  const startTime = Date.now();
  const duration = durationInSeconds * 1000;

  const tick = () => {
    const elapsedTime = Date.now() - startTime;
    const remainingTime = Math.max(duration - elapsedTime, 0);

    onTick({
      elapsedTime,
      remainingTime,
    });

    if (remainingTime > 0) {
      requestAnimationFrame(tick);
    }
  };
  tick();
}
